var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerContacted = function SvgMarkerContacted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 47,
    viewBox: "0 0 29 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.819,
    cy: 36.437,
    rx: 11.004,
    ry: 4.076,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.568,
    cy: 13.817,
    r: 7.812,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.227.571C7.485.571 2 6.08 2 12.85c0 8.51 12.239 23.044 12.239 23.044S26.454 20.94 26.454 12.85c0-6.77-5.485-12.278-12.227-12.278Zm3.689 15.873a5.19 5.19 0 0 1-3.69 1.532 5.19 5.19 0 0 1-3.688-1.532 5.26 5.26 0 0 1 0-7.409 5.17 5.17 0 0 1 3.689-1.534c1.393 0 2.703.545 3.689 1.534a5.26 5.26 0 0 1 0 7.409Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.131 16.89 9.05 13.78 8 14.832 12.131 19 21 10.052 19.958 9l-7.827 7.89Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.571,
    width: 28.454,
    height: 45.941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0.814,
    y: 30.361,
    width: 26.008,
    height: 12.151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }))));
};
export { SvgMarkerContacted as ReactComponent };
export default "data:image/svg+xml;base64,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";